module.exports = __webpack_public_path__ + "img/sdg_pt-pt_(13).d67bffe9.png";